const ABModel = require("./ABModel");
module.exports = class ABModelQuery extends ABModel {};
